/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Suspense } from 'react';
import { useDispatch } from 'react-redux';

import { DuplicateNFTsTypes } from 'store'
import { changeDuplicateNFtsVisibility } from 'services'

import PageSpinner from 'components/commons/spinner'

import DuplicateCollectionsHeader from './header';
import DuplicateCollectionItem from './item';

const DuplicateNFTsList = ({ collections, isRequesting, hasDataToLoad }: any) => {

    const dispatch = useDispatch();

    const onChangeActive = async (id: string) => {
        const response = await changeDuplicateNFtsVisibility(id);
        if (response && response.success) {
            dispatch({
                type: DuplicateNFTsTypes.UPDATE_DUPLICATE_NFTS_DATA,
                payload: response.data
            })
        }
    }

    return (
        <Suspense fallback={<PageSpinner />}>
            <div className='max-h-screen w-full overflow-x-auto py-4 mt-4 md:bg-white lg:bg-white'>
                <table className='w-full flex flex-row flex-nowrap overflow-hidden mb-4'>
                    <DuplicateCollectionsHeader />
                    <tbody className='w-full'>
                        {collections.map((col: any, index: number) => (
                            <DuplicateCollectionItem
                                {...col}
                                {...{
                                    onChangeActive
                                }}
                                key={index}
                            />
                        ))}
                    </tbody>
                </table>

                {collections && !collections.length && !isRequesting && !hasDataToLoad && (
                    <div className='flex justify-center text-gray-400'>
                        No duplicate nft collection.
                    </div>
                )}

                {isRequesting && hasDataToLoad && (
                    <div className='flex justify-center py-6'>
                        <PageSpinner />
                    </div>
                )}
            </div>
        </Suspense>
    );
};

export default DuplicateNFTsList;